export default __webpack_public_path__ + "static/media/fi_box.2670fd38.svg";